import React from 'react'

import { Spinner, StAlertIcon, theme } from '@octane/spark'
import ClientApplication from 'api/application/interfaces/ClientApplication'
import useDeclineReasons from 'hooks/useDeclineReasons'

import {
    BoxHeader,
    DeclineReasonsContainer,
    DeclineReasonItem,
    DeclineReasonList,
    DeclineReasonsSpinnerWrapper,
} from './DecisionResultDeclined.styled'

export default function DecisionResultDeclineReason({
    clientApplication,
}: {
    readonly clientApplication: ClientApplication
}): JSX.Element {
    const { declineReasons, loading } = useDeclineReasons(
        clientApplication?.uuid,
    )

    return (
        <DeclineReasonsContainer>
            <BoxHeader>
                This application was declined due to the following reasons:
            </BoxHeader>
            <DeclineReasonList>
                {loading ? (
                    <DeclineReasonsSpinnerWrapper data-testid="DecisionResultDeclined-spinner">
                        <Spinner size={24} />
                    </DeclineReasonsSpinnerWrapper>
                ) : (
                    declineReasons.map((reason) => (
                        <DeclineReasonItem key={reason}>
                            <StAlertIcon
                                color={theme.colors.alert.error}
                                width={20}
                                height={20}
                            />
                            <div>{reason}</div>
                        </DeclineReasonItem>
                    ))
                )}
            </DeclineReasonList>
        </DeclineReasonsContainer>
    )
}
